import React from "react";
import IconButton from '@mui/material/IconButton';
import RemoveCircleOutlined from '@mui/icons-material/RemoveCircleOutlined';
import {Tooltip} from '@mui/material';
import {removeSpacer} from '../../db/actions';
import {useViewBasedCardWidth} from "../../util/hooks";

export default ({caseId, spaceNumber}) => {

    const minimumWidth = useViewBasedCardWidth();

    const [showButtons, setShowButtons] = React.useState(false);

    function removeSpacerRequested(e) {
        e.preventDefault();
        removeSpacer(caseId, spaceNumber);
    }

    return (
        <div className='jb-spacer'
             onMouseOver={() => {
                 setShowButtons(true);
             }}
             onMouseOut={() => {
                 setShowButtons(false);
             }}
             style={{
                 display: "flex", flex: 1,
                 flexDirection: "column",
                 minWidth: minimumWidth,
                 padding: 0, height: 135
             }}>
            <div style={{
                display: "flex",
                flex: 1,
                justifyContent: "center",
                alignItems: "center",
                backgroundColor: '#f5f5f5',
                marginRight: "0.5em",
                borderRadius: "4px",
                visibility: showButtons ? 'visible' : 'hidden'
            }}>
                <Tooltip title={"Remove gap"}>
                    <IconButton onClick={removeSpacerRequested} size="large">
                        <RemoveCircleOutlined/>
                    </IconButton>
                </Tooltip>
            </div>
        </div>
    );
};
